export default {
  methods: {
    /**
     * Метод форматирует объект, удаляя свойства с пустыми значениями
     * @param obj - объект, который необходимо отформатировать
     */
    objectFormatter<T extends Record<string, unknown>>(obj: T): T {
      const data = { ...obj };
      if (data && Object.keys(data).length) {
        for (const key in data) {
          const value = data[key];
          if (value == null || value === '' || (Array.isArray(value) && !value.length)) {
            delete data[key];
          }
        }
      }
      return data;
    },
  },
};
